import { useMemo, useState } from "react";
import { ReactTableDataGrid } from "components/Table";
import { getSizePerPageList } from "helper/constant";

const ShopData = ({ data = [], totalSize = 0, onTableChange }) => {
    const [sizePerPage, setSizePerPage] = useState(10);
    const defaultColDef = useMemo(
        () => ({
            wrapText: true,
            autoHeight: true,
            autoHeaderHeight: true,
        }),
        []
    );

    const columns = [
        {
            field: "_id",
            width: 30,
            cellClass: "centered-cell",
            headerName: "",
            cellRenderer: ({ rowIndex, value: cell, data: row }) => rowIndex + 1,
        },
        {
            field: "name",
            cellClass: "centered-cell",
            headerName: "Shop Info",
            sortable: false,
            flex: 1,
        },
        {
            field: "result",
            cellClass: "centered-cell bt-content-fit",
            headerName: "Shipping",
            flex: 1,
            sortable: false,
            cellRenderer: ({ value }) => (
                <div className="row">
                    <div className="col-md-6 border-start border-end border-light-subtle">
                        <p>- {value?.TIKTOK?.percent || "0%"} TIKTOK SHIP</p>
                        <p>- {value?.TIKTOK?.avg_delivery_days || "0"} days AVG. Delivery</p>
                    </div>
                    <div className="col-md-6">
                        <p>- {value?.SELLER?.percent || "0%"} SELLER SHIP</p>
                        <p>- {value?.SELLER?.avg_delivery_days || "0"} days AVG. Delivery</p>
                    </div>
                </div>
            ),
        },
    ];

    return (
        <ReactTableDataGrid
            tableName="analyticOrderShopData"
            idProperty="_id"
            height={350}
            columns={columns}
            rowData={data}
            defaultColDef={defaultColDef}
            gridOptions={{
                rowHeight: 80,
                reactiveCustomComponents: true,
            }}
            totalSize={totalSize}
            paginationPageSize={sizePerPage}
            emptyText={"No data!"}
            rowSelection="multiple"
            sizePerPageList={getSizePerPageList(totalSize)}
            onTableChanged={(data) => {
                if (data.limit) setSizePerPage(data.limit);
                onTableChange?.(data);
            }}
            groupButton={() => <></>}
            isSearchText={false}
        />
    );
};

export default ShopData;
